// Archivos del admin en Cloudflare R2 (02/11/2026 — salida de Supabase Storage, fase 1).
// Se sube a través de la edge function `files` (el token de R2 no permite CORS para subir directo
// del navegador). Las URLs públicas quedan en https://images.krilic.com.ar/<bucket>/<ruta>.
// Buckets privados (bank-uploads, cut-files): no tienen URL pública; las funciones los leen.
import { supabase } from './supabase';

const FN = `${(process.env.REACT_APP_SUPABASE_URL || '').trim().replace(/\/+$/, '')}/functions/v1/files`;
const ANON = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

async function authHeaders(): Promise<Record<string, string>> {
    const { data } = await supabase.auth.getSession();
    return { Authorization: `Bearer ${data.session?.access_token || ANON}`, apikey: ANON };
}

/** Sube (o pisa) un archivo. Devuelve la URL pública (null en buckets privados). Tira error si falla. */
export async function uploadFile(bucket: string, path: string, file: Blob, contentType?: string): Promise<string | null> {
    const r = await fetch(`${FN}?action=upload&bucket=${encodeURIComponent(bucket)}&path=${encodeURIComponent(path)}`, {
        method: 'POST',
        headers: { ...(await authHeaders()), 'Content-Type': contentType || file.type || 'application/octet-stream' },
        body: file,
    });
    const d = await r.json().catch(() => ({} as any));
    if (!r.ok || !d?.ok) throw new Error(d?.error || `No se pudo subir el archivo (${r.status})`);
    return d.url ?? null;
}

export async function removeFile(bucket: string, path: string): Promise<void> {
    await fetch(FN, { method: 'POST', headers: { ...(await authHeaders()), 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'delete', bucket, path }) });
}
